import { useState } from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader, ReadOnlyBanner } from "@/components/common";
import ManualAdvance from "@/components/advance/ManualAdvance";
import BulkAdvances from "@/components/advance/BulkAdvances";
import RecentAdvances from "@/components/advance/RecentAdvances";
import { useAuth } from "@/context/AuthContext";

export default function AddAdvance() {
  const { can } = useAuth();
  const disabled = !can("admin", "advance_manager", "outlet_manager");
  const bulk = !can("outlet_manager");
  const [tick, setTick] = useState(0);
  const saved = () => setTick((t) => t + 1);
  return (
    <div className="space-y-5">
      <PageHeader title="Add Advance" subtitle={bulk ? "Record advances given to employees, one at a time or from an Excel file. Advances increase the outstanding balance and are never deducted automatically." : "Record advances given to employees one at a time. Advances increase the outstanding balance and are never deducted automatically."} />
      {disabled && <ReadOnlyBanner text="Only an administrator can add advances. You can view recent advances below." />}
      <Tabs defaultValue="manual">
        <TabsList>
          <TabsTrigger value="manual" data-testid="add-advance-tab-manual">Add Advance Manually</TabsTrigger>
          {bulk && <TabsTrigger value="bulk" data-testid="add-advance-tab-bulk">Bulk Upload Advances (Excel)</TabsTrigger>}
        </TabsList>
        <TabsContent value="manual" className="mt-4"><ManualAdvance disabled={disabled} onSaved={saved} /></TabsContent>
        {bulk && <TabsContent value="bulk" className="mt-4"><BulkAdvances disabled={disabled} onSaved={saved} /></TabsContent>}
      </Tabs>
      <RecentAdvances refreshKey={tick} />
    </div>
  );
}
